<template>
  <a-select
    class="custom-select"
    :unmount-on-close="true"
    :trigger-props="{ autoFitPopupMinWidth: true }"
    @popup-visible-change="
      (val) => {
        if (val) emit('popup-show');
      }
    "
    v-bind="$attrs"
  >
    <template v-for="(value, name) in $slots" #[name]="slotData">
      <slot :name="name" v-bind="slotData || {}"></slot>
    </template>
  </a-select>
</template>

<script setup>
const emit = defineEmits(['popup-show']);
</script>
